class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    handleFloCartBtn();
    // if (triggeredBy) this.setActiveElement(triggeredBy);
    // const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    // if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // // here the animation doesn't seem to always get triggered. A timeout seem to help
    // setTimeout(() => {
    //   this.classList.add('animate', 'active');
    // });

    // this.addEventListener(
    //   'transitionend',
    //   () => {
    //     const containerToTrapFocusOn = this.classList.contains('is-empty')
    //       ? this.querySelector('.drawer__inner-empty')
    //       : document.getElementById('CartDrawer');
    //     const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
    //     trapFocus(containerToTrapFocusOn, focusElement);
    //   },
    //   { once: true }
    // );

    // document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // Shopflo: merchant wants no cart open on add-to-cart; the header bubble count still updates above
      // this.open();
      // Shopflo: refresh the Shopflo cart in the background so the header cart icon shows the new item
      handleFloCartBtn(null, { loadCartInBackground: true, shouldPushToHistory: false });
      this.floReleaseScroll();
      this.showAddedToast(parsedState);
    });
  }

  // Shopflo: the bundle's background load sets body overflow hidden and never clears it
  floReleaseScroll() {
    let n = 0;
    const t = setInterval(() => {
      const overlay = document.getElementById('flo-cart-overlay-div');
      const open = overlay && getComputedStyle(overlay).display !== 'none';
      if (!open && document.body.style.overflow === 'hidden') document.body.style.overflow = '';
      if (++n > 20) clearInterval(t);
    }, 100);
  }

  // Shopflo: add-to-cart confirmation toast in place of opening the cart
  showAddedToast(parsedState) {
    let toast = document.getElementById('sf-atc-toast');
    if (!toast) {
      if (!document.getElementById('sf-atc-toast-styles')) {
        const style = document.createElement('style');
        style.id = 'sf-atc-toast-styles';
        style.textContent =
          '#sf-atc-toast{position:fixed;left:50%;bottom:24px;z-index:2147483000;display:flex;align-items:center;gap:12px;' +
          'width:420px;max-width:calc(100% - 32px);box-sizing:border-box;padding:12px 14px;border-radius:10px;' +
          'background:#121212;color:#fff;font-size:14px;line-height:1.35;box-shadow:0 8px 24px rgba(0,0,0,.25);' +
          'opacity:0;transform:translate(-50%,16px);transition:opacity .25s ease,transform .25s ease;pointer-events:none;}' +
          '#sf-atc-toast.sf-atc-toast--visible{opacity:1;transform:translate(-50%,0);pointer-events:auto;}' +
          '#sf-atc-toast .sf-atc-toast__icon{flex-shrink:0;display:flex;align-items:center;justify-content:center;width:32px;height:32px;}' +
          '#sf-atc-toast .sf-atc-toast__icon svg{display:block;width:32px;height:32px;}' +
          '#sf-atc-toast .sf-atc-toast__text{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;}' +
          '#sf-atc-toast .sf-atc-toast__heading{font-weight:600;}' +
          '#sf-atc-toast .sf-atc-toast__title{font-size:13px;opacity:.75;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
          '#sf-atc-toast .sf-atc-toast__title:empty{display:none;}' +
          '#sf-atc-toast .sf-atc-toast__action{flex-shrink:0;background:#fff;color:#121212;border:0;border-radius:6px;' +
          'padding:8px 12px;font:inherit;font-size:13px;font-weight:600;line-height:1;cursor:pointer;white-space:nowrap;}' +
          '@media screen and (max-width:749px){' +
          '#sf-atc-toast{left:16px;right:16px;bottom:16px;width:auto;max-width:none;transform:translateY(16px);}' +
          '#sf-atc-toast.sf-atc-toast--visible{transform:translateY(0);}}';
        document.head.appendChild(style);
      }

      toast = document.createElement('div');
      toast.id = 'sf-atc-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');

      const icon = document.createElement('span');
      icon.className = 'sf-atc-toast__icon';
      icon.setAttribute('aria-hidden', 'true');
      // Shopflo shield (same mark as the Buy Now payment-icons badge)
      icon.innerHTML =
        '<svg viewBox="0 0 32 32" fill="none"><path d="M16 29.334S26.668 24 26.668 16V6.667l-10.666-4-10.667 4V16c0 8 10.667 13.334 10.667 13.334" ' +
        'fill="#fff" fill-opacity=".25" stroke="#fff" stroke-opacity=".7" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="m19.32 10.359-4.8 4.796a2.36 2.36 0 0 1-3.338 0 2.36 2.36 0 0 1 0-3.336l3.13-3.128a2.36 2.36 0 0 1 3.339 0zm-6.445 9.376 4.799-4.796a2.36 2.360 0 0 1 3.338 0 2.36 2.36 0 0 1 0 3.336l-3.13 3.127a2.36 2.36 0 0 1-3.337 0z" fill="#fff"/></svg>';

      const text = document.createElement('span');
      text.className = 'sf-atc-toast__text';
      const heading = document.createElement('span');
      heading.className = 'sf-atc-toast__heading';
      heading.textContent = 'Added to cart';
      const productTitle = document.createElement('span');
      productTitle.className = 'sf-atc-toast__title';
      text.append(heading, productTitle);

      const viewCart = document.createElement('button');
      viewCart.type = 'button';
      viewCart.className = 'sf-atc-toast__action';
      viewCart.textContent = 'View cart';
      viewCart.addEventListener('click', () => {
        clearTimeout(this.toastTimer);
        toast.classList.remove('sf-atc-toast--visible');
        this.open();
      });

      toast.append(icon, text, viewCart);
      document.body.appendChild(toast);
    }

    toast.querySelector('.sf-atc-toast__title').textContent = (parsedState && parsedState.product_title) || '';

    clearTimeout(this.toastTimer);
    requestAnimationFrame(() => toast.classList.add('sf-atc-toast--visible'));
    this.toastTimer = setTimeout(() => toast.classList.remove('sf-atc-toast--visible'), 3000);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
